import type { Component, InjectionKey } from 'vue'

export type ComponentProps<T> = T extends new (...args: unknown[]) => { $props: infer P }
  ? P
  : T extends { props: infer P }
    ? P
    : Record<string, never>

export interface DialogOptions<T> {
  component: T
  props: ComponentProps<T>
  onClose?: () => void
}

export interface DialogItem extends DialogOptions<Component> {
  id: string
}

export interface DialogContextType {
  items: DialogItem[]
  register<T extends Component>(options: DialogOptions<T>): string
  unregister(id: string): void
}

export const DIALOG_CONTEXT = Symbol('dialog-context') as InjectionKey<DialogContextType>
